import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import './Spinner.css';

export const Spinner = ({ isLoading }) => (
  <span>
    {
      isLoading &&
      <span>
        <Row>
          <Col className="text-center" >
            <FontAwesome name="circle-o-notch" spin size="5x" />
          </Col>
        </Row>
        <Row>
          <Col className="text-center" >
            <h4>Loading...</h4>
          </Col>
        </Row>
      </span>
    }
  </span>
);

Spinner.defaultProps = {
  isLoading: false,
};

Spinner.propTypes = {
  isLoading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.jsx